<template>
  <div class="wizard-header text-left mb-8">
    <div class="flex items-center mb-4">
      <!-- <button
        v-if="onBack"
        type="button"
        @click="onBack"
        class="wizard-header__back btn p-0 mr-4"
      >
        <svg
          width="24"
          height="24"
          class="btn-icon"
        >
          <use xlink:href="/img/sprite.svg#ic_chevron-left"></use>
        </svg>
      </button> -->
      <span class="text-xl text-black-100">Step {{ currStep }}/3</span>
    </div>
    <h1 class="wizard-header__title text-black-100 font-medium mb-4">
      {{ title }}
    </h1>
    <p class="text-black-light-5">{{ subTitle }}</p>
  </div>
</template>

<script>
export default {
  name: "WizardHeader",

  props: {
    currStep: { type: Number, default: 2 },
    title: { type: String, default: "Title" },
    subTitle: { type: String, default: "Subtitle" },
    onBack: { type: Function, required: false }
  }
};
</script>

<style lang="scss" scoped>
.wizard-header {
  &__back {
    min-width: 0;
    padding: 0;
  }

  &__title {
    font-size: 2rem;
    width: 80%;
  }
}
</style>
